import React from 'react';
import PropTypes from 'prop-types';
import Ad from '../Ad/Ad';
import onResize from '../../../src/lib/on-resize';
import componentBase from '../../../src/lib/component-base';

@onResize()
@componentBase('BannerAd')
export default class BannerAd extends React.Component {
  static propTypes = {
    desktopAd: PropTypes.object,
    mobileAd: PropTypes.object,
    needSpace: PropTypes.bool,
    noAdOnLoad: PropTypes.bool,
    setRef: PropTypes.func,
    style: PropTypes.object,
    subscriptionActive: PropTypes.bool,
    topAd: PropTypes.bool,
  };

  componentDidMount() {
    this.initResizeListener();
  }

  componentWillUnmount() {
    this.removeResizeListener();
  }

  setRef = (ref) => {
    if (this.props.setRef) {
      this.props.setRef(ref);
    }
  };

  handleResize = () => {
    this.forceUpdate();
  };

  render() {
    const {
      desktopAd,
      mobileAd,
      needSpace,
      noAdOnLoad,
      style,
      subscriptionActive,
      topAd,
    } = this.props;

    let defaultRender = null;

    if (topAd && needSpace) {
      defaultRender = <div className='DefaultBannerAd' />;
    }

    const {
      isDesktop,
      isTablet,
    } = this.context && this.context.mediaBreakpoint && this.context.mediaBreakpoint.userAgent;

    if (subscriptionActive) {
      return defaultRender;
    }

    let adObj = mobileAd || desktopAd;
    if (((isDesktop || isTablet) && !this.mediaBreakpoint) ||
      (desktopAd && this.mediaBreakpoint && this.mediaBreakpoint.value > 768)) {
      adObj = desktopAd;
    }

    if (!adObj || !adObj.id) {
      return defaultRender;
    }

    return (
      <div className='BannerAd' style={style || {}}>
        <center className={this.props.topAd ? 'topAd' : ''}>
          <Ad
            noAdOnLoad={noAdOnLoad}
            {...adObj}
            key={adObj.id}
            ref={ref => this.setRef(ref)}
            subscriptionActive={subscriptionActive}
          />
        </center>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/components/BannerAd/BannerAd.js